import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const hiraganaChars = ['あ', 'い', 'う', 'え', 'お', 'か', 'き', 'く', 'け', 'こ', 'さ', 'し', 'す', 'せ', 'そ', 'た', 'ち', 'つ', 'て', 'と', 'な', 'に', 'ぬ', 'ね', 'の', 'は', 'ひ', 'ふ', 'へ', 'ほ', 'ま', 'み', 'む', 'め', 'も', 'や', 'ゆ', 'よ', 'ら', 'り', 'る', 'れ', 'ろ', 'わ', 'を', 'ん'];

const FloatingHiragana = () => {
  const floatingChars = [
    { char: 'あ', left: '5%', delay: '0s', duration: '15s', size: '28px' },
    { char: 'か', left: '15%', delay: '2s', duration: '18s', size: '22px' },
    { char: 'さ', left: '25%', delay: '4s', duration: '14s', size: '32px' },
    { char: 'た', left: '35%', delay: '1s', duration: '16s', size: '24px' },
    { char: 'な', left: '45%', delay: '3s', duration: '17s', size: '26px' },
    { char: 'は', left: '55%', delay: '5s', duration: '15s', size: '30px' },
    { char: 'ま', left: '65%', delay: '2s', duration: '19s', size: '20px' },
    { char: 'や', left: '75%', delay: '4s', duration: '14s', size: '28px' },
    { char: 'ら', left: '85%', delay: '1s', duration: '16s', size: '24px' },
    { char: 'わ', left: '92%', delay: '3s', duration: '18s', size: '22px' },
    { char: 'い', left: '10%', delay: '6s', duration: '17s', size: '26px' },
    { char: 'き', left: '30%', delay: '7s', duration: '15s', size: '20px' },
    { char: 'し', left: '50%', delay: '8s', duration: '16s', size: '32px' },
    { char: 'ち', left: '70%', delay: '9s', duration: '14s', size: '24px' },
    { char: 'に', left: '88%', delay: '10s', duration: '18s', size: '28px' },
    { char: 'う', left: '8%', delay: '11s', duration: '16s', size: '24px' },
    { char: 'く', left: '20%', delay: '12s', duration: '15s', size: '26px' },
    { char: 'す', left: '40%', delay: '13s', duration: '17s', size: '22px' },
    { char: 'つ', left: '60%', delay: '14s', duration: '14s', size: '30px' },
    { char: 'ぬ', left: '78%', delay: '15s', duration: '16s', size: '20px' },
    { char: 'ふ', left: '12%', delay: '5s', duration: '18s', size: '28px' },
    { char: 'む', left: '33%', delay: '3s', duration: '15s', size: '24px' },
    { char: 'ゆ', left: '52%', delay: '6s', duration: '17s', size: '26px' },
    { char: 'る', left: '68%', delay: '8s', duration: '14s', size: '22px' },
    { char: '을', left: '82%', delay: '4s', duration: '16s', size: '30px' },
  ];

  return (
    <>
      <style>{`
        @keyframes floatUp {
          0% {
            transform: translateY(100%) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 0.6;
          }
          90% {
            opacity: 0.6;
          }
          100% {
            transform: translateY(-100vh) rotate(360deg);
            opacity: 0;
          }
        }
        @keyframes sway {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(20px);
          }
        }
      `}</style>
      {floatingChars.map((item, idx) => (
        <div
          key={idx}
          className="absolute text-teal-400/40 font-light pointer-events-none select-none"
          style={{
            left: item.left,
            bottom: '-50px',
            fontSize: item.size,
            animation: `floatUp ${item.duration} ${item.delay} infinite linear, sway 3s ease-in-out infinite`,
          }}
        >
          {item.char}
        </div>
      ))}
    </>
  );
};

export default function PlansPage() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const personalPlans = [
    {
      name: 'Basic',
      price: '64,900',
      features: [
        '카톡 주 3회 발송',
        '유튜브 링크 제공',
        '영상 속 핵심 표현 제공',
        '쉐도잉 숙제 제공',
        '컨텐츠는 일본 방송, 영화, 드라마 등 선택 가능',
      ],
    },
    {
      name: 'Smart',
      price: '107,800',
      features: [
        'Basic 플랜의 모든 서비스',
        '작문 숙제 제공',
        'AI 작문 첨삭 제공',
      ],
    },
    {
      name: 'Pro',
      price: '140,800',
      features: [
        'Smart 플랜의 모든 서비스',
        'PDF 빈칸 넣기 시험 제공',
      ],
    },
  ];

  const bizPlan = {
    name: 'Biz',
    price: '1,419,000',
    features: [
      '카톡 주 2회 발송',
      '사업자 실무 표현 PDF 제공',
      '원어민 음성 파일',
      '원어민 녹음 첨삭',
    ],
  };

  const handleNavigate = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate(path), 300);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar scrolled={scrolled} />

      {/* Brand Section - Redesigned */}
      <section className="relative py-32 bg-gradient-to-br from-[#0A0A0A] via-[#1A1A1A] to-[#0F0F0F] overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#14B8A6]/5 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#0D9488]/5 rounded-full blur-[100px]"></div>
        </div>

        {/* Large LEXO Background Text */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[200px] sm:text-[300px] lg:text-[400px] font-black text-white/[0.02] select-none pointer-events-none tracking-tighter">
          LEXO
        </div>

        <div className="relative max-w-7xl mx-auto px-6 text-center">
          {/* Japanese Characters Floating */}
          <div className="absolute top-10 left-10 w-24 h-24 bg-gradient-to-br from-[#14B8A6]/10 to-transparent border border-[#14B8A6]/30 rounded-2xl flex items-center justify-center backdrop-blur-sm animate-float-slow">
            <span className="text-4xl font-bold text-[#14B8A6]">漢字</span>
          </div>
          <div className="absolute top-20 right-20 w-24 h-24 bg-gradient-to-br from-[#0D9488]/10 to-transparent border border-[#0D9488]/30 rounded-2xl flex items-center justify-center backdrop-blur-sm animate-float-medium">
            <span className="text-4xl font-bold text-[#0D9488]">あいう</span>
          </div>
          <div className="absolute bottom-20 left-1/4 w-24 h-24 bg-gradient-to-br from-[#14B8A6]/10 to-transparent border border-[#14B8A6]/30 rounded-2xl flex items-center justify-center backdrop-blur-sm animate-float-fast">
            <span className="text-4xl font-bold text-[#14B8A6]">アイウ</span>
          </div>

          {/* Main Content */}
          <div className="space-y-8">
            {/* LEXO Brand Badge */}
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#14B8A6]/10 to-[#0D9488]/10 border border-[#14B8A6]/30 rounded-full backdrop-blur-sm">
              <span className="text-[14px] font-semibold text-[#14B8A6] tracking-wide">LEXO - 일본어 학습의 새로운 기준</span>
            </div>

            {/* Large LEXO Text */}
            <div className="space-y-4">
              <h2 className="text-[80px] sm:text-[120px] lg:text-[160px] font-black bg-gradient-to-r from-[#14B8A6] via-[#0D9488] to-[#14B8A6] bg-clip-text text-transparent leading-[1] tracking-tighter">
                LEXO
              </h2>
              <p className="text-[24px] sm:text-[32px] font-bold text-white tracking-tight">
                일본어레스슨
              </p>
            </div>

            {/* Description */}
            <p className="text-[16px] sm:text-[18px] text-gray-400 leading-relaxed max-w-2xl mx-auto">
              카카오톡으로 매일 받는 일본어레스슨으로<br />
              자연스럽게 실력을 향상시키세요
            </p>

            {/* Stats */}
            <div className="flex items-center justify-center gap-8 pt-8">
              <div className="text-center">
                <div className="text-[36px] font-bold text-[#14B8A6] mb-1">5,000+</div>
                <div className="text-[14px] text-gray-400">학습자</div>
              </div>
              <div className="w-px h-12 bg-gray-700"></div>
              <div className="text-center">
                <div className="text-[36px] font-bold text-[#14B8A6] mb-1">95%</div>
                <div className="text-[14px] text-gray-400">만족도</div>
              </div>
            </div>
          </div>
        </div>

        <style>{`
          @keyframes float-slow {
            0%, 100% { transform: translateY(0px) rotate(-6deg); }
            50% { transform: translateY(-20px) rotate(-6deg); }
          }
          @keyframes float-medium {
            0%, 100% { transform: translateY(0px) rotate(12deg); }
            50% { transform: translateY(-25px) rotate(12deg); }
          }
          @keyframes float-fast {
            0%, 100% { transform: translateY(0px) rotate(6deg); }
            50% { transform: translateY(-18px) rotate(6deg); }
          }
          .animate-float-slow {
            animation: float-slow 3s ease-in-out infinite;
          }
          .animate-float-medium {
            animation: float-medium 3.5s ease-in-out infinite 0.5s;
          }
          .animate-float-fast {
            animation: float-fast 2.8s ease-in-out infinite 1s;
          }
        `}</style>
      </section>

      {/* Empty Section with Background */}
      <section className="relative py-20 px-6 overflow-hidden">
        <FloatingHiragana />
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/7bfc230f43904587bb818c5f5ffab5a2.jpg"
            alt="Background"
            className="w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]"></div>
        </div>
      </section>

      {/* Event Promo Section */}
      <section className="py-12 px-6">
        <div className="max-w-5xl mx-auto">
          <div 
            onClick={() => handleNavigate('/event')}
            className="group cursor-pointer bg-gradient-to-br from-[#14B8A6]/10 via-[#0D9488]/5 to-[#14B8A6]/10 border-2 border-[#14B8A6]/30 rounded-3xl p-8 md:p-12 hover:border-[#14B8A6]/60 hover:shadow-2xl hover:shadow-[#14B8A6]/20 transition-all duration-500"
          >
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
              <div className="flex items-center gap-6">
                <div className="w-20 h-20 bg-gradient-to-br from-[#14B8A6] to-[#0D9488] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-gift-2-fill text-white text-[36px]"></i>
                </div>
                <div>
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#14B8A6]/20 rounded-full mb-3">
                    <i className="ri-sparkle-fill text-[#14B8A6] text-[12px]"></i>
                    <span className="text-[12px] font-bold text-[#14B8A6]">특별 환급 이벤트</span>
                  </div>
                  <h3 className="text-[28px] md:text-[32px] font-bold text-white mb-2">
                    숙제 완수하고 <span className="text-[#14B8A6]">₩20,000</span> 환급!
                  </h3>
                  <p className="text-[14px] text-gray-400">
                    Personal 플랜 구매 후 숙제 완수 + SNS 인증 → 매달 10% 추첨
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-[14px] font-semibold text-[#14B8A6] group-hover:text-[#0D9488] transition-colors">자세히 보기</span>
                <div className="w-10 h-10 bg-[#14B8A6] rounded-full flex items-center justify-center group-hover:bg-[#0D9488] transition-colors">
                  <i className="ri-arrow-right-line text-white text-[18px] group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Spacer Section - 여백 */}
      <section className="py-10 bg-[#0A0A0A]"></section>

      {/* Title Section */}
      <section className="py-8 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-[52px] lg:text-[68px] font-bold text-white mb-6 leading-tight tracking-tight">
            나에게 맞는 플랜을<br />찾아보세요
          </h1>
          <p className="text-[17px] text-gray-300 leading-relaxed max-w-2xl mx-auto">
            Personal, Black, Biz 세 가지 카테고리의 모든 플랜을<br />
            한눈에 비교하고 선택하세요
          </p>
        </div>
      </section>

      {/* Personal Plans */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-4 mb-3">
              <h2 className="text-[28px] font-bold text-white">강한 일본어 : Personal</h2>
              <button
                onClick={() => handleNavigate('/personal')}
                className="text-[14px] text-teal-400 hover:text-teal-300 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
              >
                자세히 보기
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <p className="text-[15px] text-gray-400">개인 학습자를 위한 일본어 학습</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 justify-items-center">
            {personalPlans.map((plan, idx) => (
              <div
                key={idx}
                className="w-full max-w-[340px] bg-[#0F0F0F] border-2 border-gray-800 rounded-2xl p-8 hover:border-teal-500/50 transition-all duration-300 flex flex-col"
              >
                <div className="mb-6">
                  <h3 className="text-[24px] font-bold text-white mb-2">{plan.name}</h3>
                  <div className="flex items-baseline gap-1">
                    <span className="text-[32px] font-bold text-white">{plan.price}</span>
                    <span className="text-[15px] text-gray-400">원 (VAT 포함)</span>
                  </div>
                </div>

                <div className="space-y-3 flex-grow min-h-[200px]">
                  {plan.features.map((feature, featureIdx) => (
                    <div key={featureIdx} className="flex items-start gap-3">
                      <i className="ri-check-line text-[16px] text-teal-400 mt-0.5 flex-shrink-0"></i>
                      <span className="text-[14px] text-gray-300 leading-relaxed">{feature}</span>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => handleNavigate('/personal')}
                  className="block w-full py-3 mt-6 text-center bg-gradient-to-r from-teal-500 to-cyan-500 text-white text-[14px] font-semibold rounded-lg hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  자세히 보기
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Biz Plan */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-center">
            {/* Biz Plan */}
            <div className="w-full max-w-[420px]">
              <div className="text-center mb-8">
                <div className="flex items-center justify-center gap-4 mb-3">
                  <h2 className="text-[28px] font-bold text-white">Biz</h2>
                  <button
                    onClick={() => handleNavigate('/biz')}
                    className="text-[14px] text-rose-400 hover:text-rose-300 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
                  >
                    자세히 보기
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
                <p className="text-[15px] text-gray-400">비즈니스 일본어 전문 과정</p>
              </div>

              <div className="bg-[#0F0F0F] border-2 border-rose-500 rounded-2xl p-8 hover:border-rose-400 transition-all duration-300 shadow-lg shadow-rose-500/10 flex flex-col h-full">
                <div className="mb-6">
                  <h3 className="text-[24px] font-bold text-white mb-2">{bizPlan.name}</h3>
                  <div className="flex items-baseline gap-1">
                    <span className="text-[32px] font-bold text-white">{bizPlan.price}</span>
                    <span className="text-[15px] text-gray-400">원 (VAT 포함)</span>
                  </div>
                </div>

                <div className="space-y-3 flex-grow min-h-[120px]">
                  {bizPlan.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <i className="ri-check-line text-[16px] text-rose-400 mt-0.5 flex-shrink-0"></i>
                      <span className="text-[14px] text-gray-300 leading-relaxed">{feature}</span>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => handleNavigate('/biz')}
                  className="block w-full py-3 mt-6 text-center bg-gradient-to-r from-rose-500 to-pink-500 text-white text-[14px] font-semibold rounded-lg hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  자세히 보기
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-chat-quote-fill text-teal-400 text-[14px]"></i>
              <span className="text-[13px] font-semibold text-teal-300">Real Reviews</span>
            </div>
            <h2 className="text-[36px] font-bold text-white mb-4">수강생 후기</h2>
            <p className="text-[15px] text-gray-400">LEXO와 함께한 수강생들의 생생한 이야기</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {/* Review 1 - Personal */}
            <div className="bg-[#0F0F0F] border border-gray-800 rounded-2xl p-7 hover:border-teal-500/30 transition-all duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-[14px]"></i>
                ))}
              </div>
              <p className="text-[14px] text-gray-300 leading-relaxed mb-6">
                "히라가나도 몰랐던 제가 이제는 좋아하는 일본 애니메이션을 
                자막 없이 보게 됐어요! 카톡으로 매일 조금씩 공부하다 보니 
                어느새 귀가 트이더라고요. LEXO 덕분에 일본어가 재밌어졌어요!"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center">
                  <span className="text-[14px] font-bold text-white">김</span>
                </div>
                <div>
                  <p className="text-[14px] font-semibold text-white">김**</p>
                  <p className="text-[12px] text-gray-500">Smart 플랜 · 8개월 수강</p>
                </div>
              </div>
            </div>

            {/* Review 2 - Biz */}
            <div className="bg-[#0F0F0F] border border-gray-800 rounded-2xl p-7 hover:border-rose-500/30 transition-all duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-[14px]"></i>
                ))}
              </div>
              <p className="text-[14px] text-gray-300 leading-relaxed mb-6">
                "일본에서 대학교 다니고 상사에서 10년 넘게 일했는데, 
                독립해서 사업을 시작하면서 사업가용 일본어가 필요했어요. 
                LEXO Biz 플랜이 사업가용 커뮤니케이션에 정말 많이 도움됐습니다!"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-rose-500 to-pink-500 flex items-center justify-center">
                  <span className="text-[14px] font-bold text-white">박</span>
                </div>
                <div>
                  <p className="text-[14px] font-semibold text-white">박**</p>
                  <p className="text-[12px] text-gray-500">Biz 플랜 · 6개월 수강</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Empty Section with Background */}
      <section className="relative py-24 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20Japanese%20language%20learning%20brand%20hero%20image%20with%20elegant%20cherry%20blossom%20petals%20floating%20on%20dark%20teal%20gradient%20background%20featuring%20traditional%20Japanese%20calligraphy%20brush%20strokes%20and%20modern%20minimalist%20geometric%20patterns%20professional%20education%20aesthetic%20sophisticated%20and%20refined%20atmosphere&width=1920&height=800&seq=lexo-home-brand-003&orientation=landscape"
            alt="Background"
            className="w-full h-full object-cover object-center opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]"></div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
